export const productScoresKeys = {
  all: ["product-scores"] as const,
  list: () => [...productScoresKeys.all, "list"] as const,
  byProduct: (productId: string) => [...productScoresKeys.all, "by-product", productId] as const,
};
